import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

/**
 * Portaled "…" dropdown (the sidebar/list panes sit inside split panes whose
 * splitters form stacking contexts — same reason ExtensionTreeSection's
 * context menu portals to <body>).
 */
export function ItemMenu({ anchorRef, items, onClose }) {
  const menuRef = useRef(null);
  const [pos, setPos] = useState(null);

  useEffect(() => {
    const rect = anchorRef.current?.getBoundingClientRect();
    if (rect) setPos({ left: Math.max(8, rect.right - 176), top: rect.bottom + 4 });
  }, [anchorRef]);

  useEffect(() => {
    const onMouseDown = (e) => {
      if (menuRef.current?.contains(e.target) || anchorRef.current?.contains(e.target)) return;
      onClose();
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [anchorRef, onClose]);

  if (!pos) return null;
  return ReactDOM.createPortal(
    <div
      ref={menuRef}
      className="fixed z-50 min-w-40 animate-fadeIn rounded-lg border border-gray-200 bg-white py-2 shadow-lg dark:border-zinc-700 dark:bg-zinc-900"
      style={{ left: pos.left, top: pos.top }}
      onContextMenu={(e) => e.preventDefault()}
    >
      {items.map(({ id, label, Icon, danger, onSelect }) => (
        <button
          key={id}
          type="button"
          className={`ctx-menu-btn${danger ? ' ctx-menu-btn--danger' : ''}`}
          onClick={() => {
            onClose();
            onSelect();
          }}
        >
          <Icon size={14} />
          <span>{label}</span>
        </button>
      ))}
    </div>,
    document.body
  );
}
